<!--
  TODO: Consider migrating this component to use DataGrid for consistency
  with other list components in the application (see request contents module)
-->
<template>
  <div class="collection-modal" data-testid="add-to-collections-modal">
    <h5 class="modal-title">Add to collection</h5>
    <div class="modal-body">
      <CreateCollection v-if="!isListEmpty" :item-id="itemId" data-testid="collections-modal-create" :show-input="false" />

      <div v-if="!isLoaded" data-testid="collections-modal-loader" class="collections-loader"><Icon name="general.spinner" size="base" /></div>
      <div v-if="isLoaded && filteredList.length > 0" class="collections-list" ref="scrollable" data-testid="collections-modal-collections-list">
        <CollectionItem
          v-for="collection in filteredList"
          :key="collection.id"
          :data-testid="`collections-modal-collection-${collection.id}`"
          class="collection-item"
          :collection="collection"
          :selected="isSelected(collection)"
          :is-saving="toggleSaveState.includes(collection.id)"
          @toggle="() => collectionsStore.toggleItem(itemId, collection.id)"
        />
      </div>
      <div v-if="isListEmpty" class="collections-empty-state">
        <h2 class="inline-block mb-4 font-bold">Group It Up</h2>
        <span class="inline-block mb-5">
          Organize your content into collections for easy access and consumption of multiple screenshots and recordings. Great for onboarding and tutorials!
        </span>
        <CreateCollection :show-input="true" :item-id="itemId" data-testid="collections-modal-create" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, Ref, computed } from 'vue';
import { useInfiniteScroll } from '@vueuse/core';
import CollectionItem from './CollectionItem.vue';
import { useCollectionsStore, CollectionItemInterface } from '@/store/useCollectionsStore';
import { storeToRefs } from 'pinia';
import CreateCollection from './CreateCollection.vue';
import { Icon } from '@/storybook';

const props = defineProps<{ itemId: string }>();

const collectionsStore = useCollectionsStore();
const { filteredList, toggleSaveState } = storeToRefs(collectionsStore);

const scrollable = ref(null);
const isSelected = (collection: CollectionItemInterface) => collection.items.includes(props.itemId);
const isLoaded: Ref<boolean> = ref(false);
const isListEmpty = computed(() => isLoaded.value && filteredList.value.length === 0);

useInfiniteScroll(scrollable, () => collectionsStore.loadMore());
onBeforeMount(async () => {
  isLoaded.value = false;
  await collectionsStore.load().finally(() => (isLoaded.value = true));
});
</script>

<style scoped>
.collection-modal {
  @apply flex flex-col gap-2 w-full p-5 md:w-128;
}
.modal-title {
  @apply font-semibold mb-1;
}
.modal-body {
  @apply flex flex-col gap-2 p-4 rounded-10 border border-slate-300 dark:border-zinc-700;
}
.collections-loader {
  @apply flex flex-col justify-center items-center h-[210px] px-1;
}

.collections-empty-state {
  /* @apply flex flex-col justify-center items-center px-1; */
}

.collections-list {
  @apply flex flex-col gap-3 max-h-[210px] overflow-y-auto px-1;
}
.collection-item {
  @apply flex justify-between items-center;
}
</style>
